// import Vue from 'vue'
// import VueGlide from 'vue-glide-js'
// import 'vue-glide-js/dist/vue-glide.css'

// Vue.use(VueGlide)

export default defineNuxtPlugin((nuxtApp) => {
  //TODO port glide to vue 3/nuxt 3 or find alternative
})
